import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiPaginate, ApiPaginateResult } from '../apiservices/apipaginated';
import { APIService } from '../apiservices/apiservices';

@Injectable()

export class PerfilProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }
  
  getPaginated(paginacao: ApiPaginate, params = {}) : Promise<ApiPaginateResult> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
      let url = APIService.API_URL + 'perfil?operacao=pageView&' + paginacao.geraAPIUrl();

      me.http.get(url, {headers: this.header, params}).subscribe((result: ApiPaginateResult) => {
        resolve(result);
      },
      (error) => {
        reject(error);
      });
    });
  }
  
  /**
   * Lista usuários
   * @param filtro filtro de nome ou cpf do usuário
   * @returns 
   */
  get(filtro:any, idTipoUsuario = null) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'perfil?searchString=' + filtro;

      if(idTipoUsuario != 1)
      {
        url += '&operacao=' + 'perfillojista';
      }

      if (idTipoUsuario) {
        url += '&idTipoUsuario=' + idTipoUsuario;
      }
      
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta dos perfis.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Atualiza usuário
   * @param dadosJson json com os dados do usuário
   * @returns 
   */
  addupdate(dadosJson:any) {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      var requestData=JSON.stringify(dadosJson);
      let url = APIService.API_URL + 'perfil';
      //console.log(requestData);
      me.http.post(url,requestData,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData.status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }
                me.itemret=datasuccess;
            }
            else{
              //console.log(jsonData.erro);
              var errodatavazio={
                'Item':null,
                'erro':'Erro na atualização do perfil.'
              }
              me.itemret=errodatavazio;
            }
            
            resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Não há consultas.'
            }
            me.itemret=errodatavazio1;
          }
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

  /**
   * Apaga o perfil
   * @param id id do perfil
   * @returns 
   */
  apagarPerfil(id: any): Promise<{Item: any, erro: ""}> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'perfil';
      
      me.http.delete(url,{headers:me.header, params: {
        id
      }})
        .subscribe((result: any) => {
            resolve({
              Item: result?.status_ret != "NOK" ? result : null,
              erro: result?.status_ret == "NOK" ? result?.erro : null
            });
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }

}
